// extracted by mini-css-extract-plugin
module.exports = {"container":"TabAbout_container__i9Mle","title":"TabAbout_title__onwkS","tagsContainer":"TabAbout_tagsContainer__bPoWV","tag":"TabAbout_tag__9qqBE"};